import * as React from "react";
import i18next from "i18next";
import {
  Alignment,
  Button,
  Classes,
  Navbar,
  Menu,
  MenuDivider,
  MenuItem,
  Position,
  Popover,
  Divider,
  Icon,
} from "@blueprintjs/core";

import { Link } from "react-router-dom";
import { withTranslation } from "react-i18next";
import { Trans } from "react-i18next";

import LanguageSelector from "../languageSelector";
import LogOutBtn from "../logOut";
import DarkModeSwitch from "../DarkModeSwitch";
import NotificationsPannel from "../../Notifications/NotificationsPannel";
import { NotifALPR } from "./NotifALPR";
import ClientPhonie from "../../Phonie/ClientPhonie";
import { cachedGroups } from "../../Supervision/SupervisionMenu";

import { getSetting } from "../../Settings/InstallationSettings";

export class DropdownMenu extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      opened: false,
    };
  }
  render() {
    const menu = (
      <Menu className={Classes.POPOVER_DISMISS}>
        <Link to="/home" className="bp5-menu-item">
          <Icon icon="home" color="grey" />
          <span> </span>
          <Trans>home</Trans>
        </Link>
        {localStorage.getItem("perm_financial") === "true" && (
          <Link to="/financial" className="bp5-menu-item">
            <Icon icon="document" color="grey" />
            <span> </span>
            <Trans>financial report</Trans>
          </Link>
        )}
        {localStorage.getItem("perm_activity") === "true" && (
          <Link to="/activity" className="bp5-menu-item">
            <Icon icon="timeline-line-chart" color="grey" />
            <span> </span>
            <Trans>activity report</Trans>
          </Link>
        )}
        {localStorage.getItem("perm_SPV") === "true" && (
          <Link to="/supervision" className="bp5-menu-item">
            <Icon icon="drive-time" color="grey" />
            <span> </span>
            <Trans>supervision menu</Trans>
          </Link>
        )}
        {localStorage.getItem("perm_custom_report") === "true" &&
          localStorage.getItem("perm_custom_report_display") === "true" && (
            <Link to="/report" className="bp5-menu-item">
              <Icon icon="timeline-bar-chart" color="grey" />
              <span> </span>
              <Trans>custom report</Trans>
            </Link>
          )}
        {getSetting("enable bonification", false) === true &&
          localStorage.getItem("perm_bonification") === "true" && (
            <Link to="/bonification" className="bp5-menu-item">
              <Icon icon="tag" color="grey" />
              <span> </span>
              <Trans>Bonitick</Trans>
            </Link>
          )}
        {getSetting("enable external access controle", false) === true &&
          localStorage.getItem("perm_extern_access_ctrl") === "true" && (
            <Link to="/externAccessControl" className="bp5-menu-item">
              <Icon icon="changes" color="grey" />
              <span> </span>
              <Trans>external access control</Trans>
            </Link>
          )}
        {localStorage.getItem("perm_tarif") === "true" && (
          <Link to="/tarif" className="bp5-menu-item">
            <Icon icon="dollar" color="grey" />
            <span> </span>Tarif
          </Link>
        )}
        {localStorage.getItem("perm_ALPR") === "true" && (
          <Link to="/alpr" className="bp5-menu-item">
            <Icon icon="widget-button" color="grey" />
            <span> </span>ALPR
          </Link>
        )}

        {localStorage.getItem("detection_classification") === "true" && (
          <Link to="/dc" className="bp5-menu-item">
            <Icon icon="widget-button" color="grey" />
            <span> </span>ALPR
          </Link>
        )}

        {localStorage.getItem("perm_reservation_display") === "true" && (
        <Link to="/bookings" className="bp5-menu-item">
          <Icon icon="timeline-events" color="grey" />
          <span> </span>
          <Trans>booking management</Trans>
        </Link>
        )}
        {localStorage.getItem("perm_phonie") === "true" && (
          <Link to="/phonie" className="bp5-menu-item">
            <Icon icon="headset" color="grey" />
            <span> </span>
            <Trans>phonie</Trans>
          </Link>
        )}
        {localStorage.getItem("perm_code") !== "undefined" && (
          <Link to="/code" className="bp5-menu-item">
            <Icon icon="layout-grid" color="grey" />
            <span> </span>
            <Trans>codes list</Trans>
          </Link>
        )}
        {localStorage.getItem("IRVE one ticket") === "true" && (
          <li>
            <Link to="/irve" className="bp5-menu-item lightning">
              <Trans>IRVE</Trans>
            </Link>
          </li>
        )}

        <MenuDivider />
        <MenuItem icon="cog" text="Settings...">
          <MenuItem icon="translate" text={"translation"}>
            <MenuItem
              text="🇫🇷"
              intent={i18next.language === "fr" ? "primary" : "none"}
              onClick={() => {
                this.setState({ lang: "fr" });
                i18next.changeLanguage("fr");
              }}
            />
            <MenuItem
              text="🇬🇧"
              intent={i18next.language === "en" ? "primary" : "none"}
              onClick={() => {
                this.setState({ lang: "en" });
                i18next.changeLanguage("en");
              }}
            />
          </MenuItem>
          <Link to="/settings" className="bp5-menu-item">
            <Icon icon="user" color="grey" />
            <span> </span>
            <Trans>Account</Trans>
          </Link>
        </MenuItem>
      </Menu>
    );
    return (
      <Popover content={menu} placement="right-end">
        <Button
          id="content-mobile"
          icon={this.state.opened ? "menu-open" : "menu"}
          onClick={() => {
            this.setState({ opened: !this.state.opened });
          }}
        />
      </Popover>
    );
  }
}

class NavBar extends React.Component {
  constructor() {
    super();
    this.state = {
      toDisp: [
        "signin",
        "certs",
        "call",
        "camera",
        "settings/events",
        "eventflow",
        "screenshot",
      ].some((i) => window.location.href.includes(i)),
      groupList: [],
      active: window.location.pathname,
    };
  }

  async componentDidMount() {
    const groupList = [
      <Link to={"/supervision/0"} key="grp0" className="bp5-menu-item">
        <Trans>global view</Trans>
      </Link>,
    ];
    const groups = await cachedGroups();
    for (const groupId in groups)
      groupList.push(
        <Link
          to={"/supervision/" + groupId}
          key={"grp" + groupId}
          className="bp5-menu-item"
        >
          {groups[groupId]?.label}{" "}
        </Link>
      );

    this.setState({ groupList: groupList });
  }

  render() {
    return (
      <div>
        {!this.state.toDisp && (
          <Navbar fixedToTop={true}>
            <Navbar.Group align={Alignment.LEFT}>
              <Navbar.Heading className="noselect">
                <span role="img" aria-label="">
                  🚗
                </span>{" "}
                {<Trans>WiLix</Trans>}
              </Navbar.Heading>
              <DropdownMenu id="content-mobile" groups={this.state.groupList} />

              <Link
                to="/home"
                style={{ textDecoration: "none", color: "inherit" }}
              >
                <Button
                  minimal={true}
                  icon="home"
                  text={window.innerWidth > 500 ? <Trans>home</Trans> : ""}
                  onClick={() => this.setState({ active: "/ow/view/home" })}
                  active={
                    this.state.active === "/ow/view/home" ||
                    this.state.active === "/ow/view"
                  }
                  id="content-desktop"
                />
              </Link>

              {localStorage.getItem("perm_financial") === "true" &&
                localStorage.getItem("perm_financial_display") === "true" && (
                  <Link
                    to="/financial"
                    style={{ textDecoration: "none", color: "inherit" }}
                  >
                    <Button
                      minimal={true}
                      icon="document"
                      text={
                        window.innerWidth > 500 ? (
                          <Trans>financial report</Trans>
                        ) : (
                          ""
                        )
                      }
                      onClick={() =>
                        this.setState({ active: "/ow/view/financial" })
                      }
                      active={this.state.active === "/ow/view/financial"}
                      id="content-desktop"
                    />
                  </Link>
                )}

              {localStorage.getItem("perm_activity") === "true" &&
                localStorage.getItem("perm_activity_display") === "true" && (
                  <Link
                    to="/activity"
                    style={{ textDecoration: "none", color: "inherit" }}
                  >
                    <Button
                      minimal={true}
                      icon="timeline-line-chart"
                      text={
                        window.innerWidth > 500 ? (
                          <Trans>activity report</Trans>
                        ) : (
                          ""
                        )
                      }
                      onClick={() =>
                        this.setState({ active: "/ow/view/activity" })
                      }
                      active={this.state.active === "/ow/view/activity"}
                      id="content-desktop"
                    />
                  </Link>
                )}

              {localStorage.getItem("perm_custom_report") === "true" &&
                localStorage.getItem("perm_custom_report_display") ===
                  "true" && (
                  <Link
                    to="/report"
                    style={{ textDecoration: "none", color: "inherit" }}
                  >
                    <Button
                      minimal={true}
                      icon="timeline-bar-chart"
                      text={
                        window.innerWidth > 500 ? (
                          <Trans>custom report</Trans>
                        ) : (
                          ""
                        )
                      }
                      onClick={() =>
                        this.setState({ active: "/ow/view/report" })
                      }
                      active={this.state.active === "/ow/view/report"}
                      id="content-desktop"
                    />
                  </Link>
                )}

              {localStorage.getItem("perm_SPV") === "true" &&
                localStorage.getItem("perm_SPV_display") === "true" && (
                  <Popover
                    content={
                      <Menu>
                        <Link to="/supervision" className="bp5-menu-item">
                          <Trans>supervision menu</Trans>
                        </Link>
                        <Divider />
                        {this.state.groupList}
                      </Menu>
                    }
                    position={Position.BOTTOM}
                    interactionKind="hover"
                  >
                    <Link
                      id="button_sup"
                      to="/supervision"
                      style={{ textDecoration: "none", color: "inherit" }}
                    >
                      <Button
                        minimal={true}
                        icon="drive-time"
                        text={window.innerWidth > 500 ? "Supervision" : ""}
                        onClick={() =>
                          this.setState({ active: "/ow/view/supervision" })
                        }
                        active={this.state.active === "/ow/view/supervision"}
                        id="content-desktop"
                      />
                    </Link>
                  </Popover>
                )}

              {getSetting("enable bonification", false) === true &&
                localStorage.getItem("perm_bonification") === "true" && (
                  <Link
                    id="button_sup"
                    to="/bonification"
                    style={{ textDecoration: "none", color: "inherit" }}
                  >
                    <Button
                      minimal={true}
                      icon="tag"
                      text={
                        window.innerWidth > 500 ? <Trans>Bonitick</Trans> : ""
                      }
                      onClick={() => this.setState({ active: "/bonification" })}
                      active={this.state.active === "/bonification"}
                      id="content-desktop"
                    />
                  </Link>
                )}
              {getSetting("enable external access controle", false) === true &&
                localStorage.getItem("perm_extern_access_ctrl") === "true" && (
                  <Link
                    id="button_sup"
                    to="/externAccessControl"
                    style={{ textDecoration: "none", color: "inherit" }}
                  >
                    <Button
                      minimal={true}
                      icon="changes"
                      text={
                        window.innerWidth > 500 ? (
                          <Trans>external access control</Trans>
                        ) : (
                          ""
                        )
                      }
                      onClick={() =>
                        this.setState({ active: "/externAccessControl" })
                      }
                      active={this.state.active === "/externAccessControl"}
                      id="content-desktop"
                    />
                  </Link>
                )}
              {localStorage.getItem("perm_tarif") === "true" && (
                <Link
                  to="/tarif"
                  style={{ textDecoration: "none", color: "inherit" }}
                >
                  <Button
                    minimal={true}
                    icon="dollar"
                    text={window.innerWidth > 500 ? "Tarif" : ""}
                    onClick={() => this.setState({ active: "/ow/view/tarif" })}
                    active={this.state.active === "/ow/view/tarif"}
                    id="content-desktop"
                  />
                </Link>
              )}

              {localStorage.getItem("perm_ALPR") === "true" && (
                <Link
                  to="/alpr"
                  style={{ textDecoration: "none", color: "inherit" }}
                >
                  <Button
                    minimal={true}
                    icon="widget-button"
                    text={
                      <span>
                        {window.innerWidth > 500 ? "ALPR" : ""} <NotifALPR />
                      </span>
                    }
                    onClick={() => this.setState({ active: "/ow/view/alpr" })}
                    active={this.state.active === "/ow/view/alpr"}
                    id="content-desktop"
                  />
                </Link>
              )}

              {localStorage.getItem("detection_classification") === "true" && (
                <Link
                  to="/dc"
                  style={{ textDecoration: "none", color: "inherit" }}
                >
                  <Button
                    minimal={true}
                    icon="widget-button"
                    text={"ALPR"}
                    onClick={() => this.setState({ active: "/ow/view/dc" })}
                    active={this.state.active === "/ow/view/dc"}
                    id="content-desktop"
                  />
                </Link>
              )}

              {localStorage.getItem("perm_reservation_display") === "true" && (
                <Link
                  to="/bookings"
                  style={{ textDecoration: "none", color: "inherit" }}
                >
                  <Button
                    minimal={true}
                    icon="timeline-events"
                    text={<Trans>bookings</Trans>}
                    onClick={() => this.setState({ active: "/ow/view/bookings" })}
                    active={this.state.active === "/ow/view/bookings"}
                    id="content-desktop"
                  />
                </Link>
              )}

              {localStorage.getItem("perm_phonie") === "true" &&
                localStorage.getItem("perm_SPV_display") === "true" && (
                  <>
                    <Link
                      to="/phonie"
                      style={{ textDecoration: "none", color: "inherit" }}
                    >
                      <Button
                        minimal={true}
                        icon="headset"
                        text={
                          window.innerWidth > 500 ? <Trans>phonie</Trans> : ""
                        }
                        onClick={() =>
                          this.setState({ active: "/ow/view/phonie" })
                        }
                        active={this.state.active === "/ow/view/phonie"}
                        id="content-desktop"
                      />
                    </Link>
                    <ClientPhonie />
                  </>
                )}
              {localStorage.getItem("perm_code") !== "undefined" && (
                <Link
                  to="/code"
                  style={{ textDecoration: "none", color: "inherit" }}
                >
                  <Button
                    className={Classes.MINIMAL}
                    icon="layout-grid"
                    text={
                      window.innerWidth > 500 ? <Trans>codes list</Trans> : ""
                    }
                    onClick={() => this.setState({ active: "/ow/view/code" })}
                    active={this.state.active === "/ow/view/code"}
                    id="content-desktop"
                  />
                </Link>
              )}
              {getSetting("IRVE one ticket", false) && (
                <Link
                  to="/irve"
                  style={{ textDecoration: "none", color: "inherit" }}
                >
                  <Button
                    className={Classes.MINIMAL}
                    icon="lightning"
                    text={window.innerWidth > 500 ? <Trans>IRVE</Trans> : ""}
                    onClick={() => this.setState({ active: "/irve" })}
                    active={this.state.active === "/irve"}
                  />
                </Link>
              )}
            </Navbar.Group>

            <Navbar.Group align={Alignment.RIGHT}>
              <LanguageSelector />
              <LogOutBtn />
              <NotificationsPannel />
              <DarkModeSwitch />
              <Link
                to="/settings"
                style={{ textDecoration: "none", color: "inherit" }}
              >
                <Button
                  minimal={true}
                  icon="settings"
                  onClick={() => this.setState({ active: "/ow/view/settings" })}
                  active={this.state.active === "/ow/view/settings"}
                />
              </Link>
            </Navbar.Group>
          </Navbar>
        )}
      </div>
    );
  }
}

export default withTranslation()(NavBar);
